import { type Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { CheckoutLayoutComponent } from './layouts/checkout-layout/checkout-layout.component';
import { CleanLayoutComponent } from './layouts/clean-layout/clean-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'catalog',
        loadComponent: () =>
          import('./pages/catalog/catalog.component').then(
            (m) => m.CatalogComponent,
          ),
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () =>
          import(
            './pages/terms-and-conditions/terms-and-conditions.component'
          ).then((m) => m.TermsAndConditionsComponent),
      },
      {
        path: 'privacy-policies',
        loadComponent: () =>
          import('./pages/privacy-policies/privacy-policies.component').then(
            (m) => m.PrivacyPoliciesComponent,
          ),
      },
      {
        path: 'product/:id',
        loadComponent: () =>
          import('./pages/product-details/product-details.component').then(
            (m) => m.ProductDetailsComponent,
          ),
      },
      {
        path: 'user',
        loadComponent: () =>
          import('./pages/user/user.component').then((m) => m.UserComponent),
        canActivate: [authGuard],
        children: [
          { path: '', redirectTo: 'profile', pathMatch: 'full' },
          {
            path: 'profile',
            loadComponent: () =>
              import(
                './pages/user/pages/user-profile/user-profile.component'
              ).then((m) => m.UserProfileComponent),
          },
          {
            path: 'addresses',
            loadComponent: () =>
              import(
                './pages/user/pages/user-addresses/user-addresses.component'
              ).then((m) => m.UserAddressesComponent),
          },
          {
            path: 'orders',
            loadComponent: () =>
              import(
                './pages/user/pages/user-orders/user-orders.component'
              ).then((m) => m.UserOrdersComponent),
          },
          {
            path: 'orders/:id',
            loadComponent: () =>
              import(
                './pages/user/pages/user-orders/user-orders.component'
              ).then((m) => m.UserOrdersComponent),
          },
        ],
      },
      {
        path: 'order-success',
        loadComponent: () =>
          import('./pages/order-success/order-success.component').then(
            (m) => m.OrderSuccessComponent,
          ),
        canActivate: [authGuard],
      },
      {
        path: 'order-failure',
        loadComponent: () =>
          import('./pages/order-failure/order-failure.component').then(
            (m) => m.OrderFailureComponent,
          ),
        canActivate: [authGuard],
      },
    ],
  },
  {
    path: 'checkout',
    component: CheckoutLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./pages/checkout/checkout.component').then(
            (m) => m.CheckoutComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: CleanLayoutComponent,
    children: [
      {
        path: 'password-reset',
        loadComponent: () =>
          import('./pages/password-reset/password-reset.component').then(
            (m) => m.PasswordResetComponent,
          ),
      },
      {
        path: 'auth/google-callback',
        loadComponent: () =>
          import('./pages/google-callback/google-callback.component').then(
            (m) => m.GoogleCallbackComponent,
          ),
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'error',
        loadComponent: () =>
          import(
            './pages/internal-server-error/internal-server-error.component'
          ).then((m) => m.InternalServerErrorComponent),
      },
      {
        path: '**',
        loadComponent: () =>
          import('./pages/not-found/not-found.component').then(
            (m) => m.NotFoundComponent,
          ),
      },
    ],
  },
];
